import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

const AccessibilityPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={10}
              offset={1}
              md={8}
              mdOffset={2}
            >
              <Stack hasGutter>
                <StackItem>
                  <Content
                    component="h1"
                    style={{ textAlign: "center" }}
                  >
                    Dostępność informacyjno-komunikacyjna
                  </Content>
                </StackItem>

                <StackItem>
                  <Content
                    component="p"
                    style={{ textAlign: "center" }}
                  >
                    Informacje dotyczące dostępności
                    informacyjno-komunikacyjnej szkoły.
                  </Content>
                </StackItem>
              </Stack>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
  span={12}
  md={8}
  mdOffset={2}
>
  <Card isGlass>
    <CardBody>
      <iframe
        src="https://www.youtube.com/embed/uWCPMU16pu0"
        title="Dostępność informacyjno-komunikacyjna - CKZiU Wyrzysk"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        style={{
          display: "block",
          width: "100%",
          aspectRatio: "16 / 9",
          border: 0
        }}
      />
    </CardBody>
  </Card>
</GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default AccessibilityPage;